import React from 'react';
import PatientQueue from './PatientQueue';

const RpmAddonUnverifiedQueue = () =>
    <PatientQueue
        showFilters
        showScheduleCallFilter
        showRpmDeviceFilter
        patientDetailColumn
        providerDetailColumn
        actionsColumn
        page
        lastOutCallColumn
        lastHistoryColumn
        callAttemptsCol
        reengageFilter
        reengageIndicator
        showEligibilityFilter
        showRpmUnverifiedQueueHeader
        rpmUnverifiedProgramColumn
        queue="rpmunverified"
        endpoint="RPMUnverified"
        label="RPM Unverified"
        queueSubtitle="All patients in this queue are RPM eligible — CCM + APCM."
        showSort
        sortOptions={[
            {
                'name': 'Last Called Ascending',
                'key': 'lastOutCallTs&dir=asc',
            },
            {
                'name': 'Last Called Descending',
                'key': 'lastOutCallTs&dir=desc',
            }
        ]}
    />;

export default RpmAddonUnverifiedQueue;
